var _="@[user:__id__|__display__]",d={id:"__id__",display:"__display__"};export{d as PLACEHOLDERS,_ as USER_MARKUP};
